// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3G_tV","buttons":"Footer_buttons__DdtF9"};